import React from "react";
import { useSelector } from "react-redux";
import { Box, Card, CardContent } from "@mui/material";
import "./css/main.css";
import "./css/util.css";
import "../../assets/css/page/Auth.scss";

const NewAuthLayout = ({ children }) => {
  const reducer = useSelector((reducer: any) => reducer);
  const {
    AccountReducer: { whitelabelDetails },
  } = reducer;
  return (
    <Box
      className="flex-row-center"
      sx={{ minHeight: "100vh", background: "#181818" }}
    >
      <Box
        className="flex-xy-center flex-column m-3"
        sx={{
          width: "100%",
          minWidth: "300px",
          maxWidth: "450px",
        }}
      >
        {whitelabelDetails?.imgLink && (
          <Box className="flex-row-center mb-2">
            <img
              style={{
                height: "60px",
                width: "auto",
                filter: whitelabelDetails?.imgBackground
                  ? ""
                  : "brightness(0) invert(1)",
                background: whitelabelDetails?.imgBackground || "",
                borderRadius: 8,
              }}
              src={whitelabelDetails?.imgLink}
              alt="logo"
            />
          </Box>
        )}
        <Card
          sx={{
            width: "100%",
            boxShadow:
              " 0 10px 15px -3px rgba(0, 0, 0, 0.1),  0 4px 6px -4px rgba(0, 0, 0, 0.1)",
            borderRadius: 2,
          }}
        >
          <CardContent
            sx={{
              py: 3,
              px: { xs: 2, md: 3 },
              maxHeight: "90vh",
              overflowY: "auto",
              scrollbarWidth: "none",
              "&::-webkit-scrollbar": {
                display: "none",
              },
            }}
          >
            {children}
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
};

export default NewAuthLayout;
